import React from "react";
import styled from "styled-components";
// import { Button } from "./Button";
import { useState } from "react";

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  li {
    padding: 18px 0px;
    text-align: center;
  }
  @media (max-width: 768px) {
    flex-flow: column nowrap;

    background: linear-gradient(
      45deg,
      rgba(86, 58, 250, 0.9) 0%,
      rgba(116, 15, 214, 0.9) 100%
    );
    /* background: #2b2b2b; */
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    li {
      color: #fff;
    }
  }
`;

const NavLink = styled.a`
  text-decoration: none;
  color: ${(props) => (props.active ? "#6f42c1" : "#180e0e")};
  font-size: 15px;
  padding: 0 8px;

  font-weight: bold;
  &:hover {
    color: #000;
  }
  @media (max-width: 768px){
    color:  ${(props) => (props.active ? "#fff" : "#fff")}
   
  
  }
`;

const RightNav = ({ open }) => {
  const [currentActive, setCurrentActive] = useState("home");

  window.onload = () => {
    var homePosition =
      document.getElementById("hero").getBoundingClientRect().height - 20;
    var aboutPosition =
      document.getElementById("about").getBoundingClientRect().height +
      homePosition +
      document.getElementById("counter").getBoundingClientRect().height;
    var servicesPosition =
      document.getElementById("services").getBoundingClientRect().height +
      aboutPosition;
    var ourTeamPosition =
      document.getElementById("testimonial").getBoundingClientRect().height +
      servicesPosition;
    var contactPosition =
      document.getElementById("contact").getBoundingClientRect().height +
      ourTeamPosition;

    document.addEventListener("scroll", () => {
      var currentPosition = window.scrollY;
      if (currentPosition <= homePosition) {
        setCurrentActive("home");
      } else if (currentPosition <= aboutPosition) {
        setCurrentActive("about");
      } else if (currentPosition <= servicesPosition) {
        setCurrentActive("services");
      } else if (currentPosition <= ourTeamPosition) {
        setCurrentActive("ourTeam");
      } else if (currentPosition <= contactPosition) {
        setCurrentActive("contact");
      } else {
        setCurrentActive("home");
      }
    });
  };

  return (
    <Ul open={open}>
      <li>
        <NavLink href="#hero" active={currentActive === "home" ? true : false}>
          Home
        </NavLink>
      </li>

      <li>
        <NavLink
          href="#about"
          active={currentActive === "about" ? true : false}
        >
          About
        </NavLink>
      </li>
      <li>
        <NavLink
          href="#services"
          active={currentActive === "services" ? true : false}
        >
          Services
        </NavLink>
      </li>
      {/* <li> */}
        {/* <NavLink
          href="#testimonial"
          active={currentActive === "ourTeam" ? true : false}
        >
          Our Team
        </NavLink> */}
      {/* </li> */}
      <li>
        <NavLink
          href="#contact"
          active={currentActive === "contact" ? true : false}
        >
          Contact us
        </NavLink>
      </li>

      <li>{/* <Button className="disabled">Login</Button> */}</li>
    </Ul>
  );
};

export default RightNav;
